import brandPortalOrdersbrandOrderToken from "@faire/web-api/routes/brand-portal/orders/brandOrderToken";
import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { Bold } from "../common/Bold";
export var SplitOrderIA = function SplitOrderIA(_ref) {
  var context = _ref.context;
  return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "B7GCRh",
    defaultMessage: [{
      "type": 0,
      "value": "Il est utile de diviser une commande lorsque vous devez modifier des détails pour certains produits sans changer la date de réapprovisionnement des articles. Pour diviser une commande :"
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "doQrD2",
    defaultMessage: [{
      "type": 0,
      "value": "1. Rendez-vous sur la "
    }, {
      "children": [{
        "type": 0,
        "value": "page des détails de la commande"
      }],
      "type": 8,
      "value": "OrderLinkFormatting"
    }, {
      "type": 0,
      "value": "."
    }],
    values: {
      OrderLinkFormatting: function OrderLinkFormatting(chunks) {
        var _context$brandOrder, _context$brandOrder$b;
        return _OrderLinkFormatting(chunks, (_context$brandOrder = context.brandOrder) === null || _context$brandOrder === void 0 ? void 0 : (_context$brandOrder$b = _context$brandOrder.brand_order) === null || _context$brandOrder$b === void 0 ? void 0 : _context$brandOrder$b.token);
      }
    }
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "9rbh3V",
    defaultMessage: [{
      "type": 0,
      "value": "2. Sélectionnez ensuite l'option "
    }, {
      "children": [{
        "type": 0,
        "value": "Diviser"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": ", généralement située sur la droite."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "+ArNhy",
    defaultMessage: [{
      "type": 0,
      "value": "3. Vous verrez tous les produits de la commande avec leurs quantités. Indiquez ici les quantités que vous souhaitez déplacer vers une nouvelle commande."
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "zCnJLL",
    defaultMessage: [{
      "type": 0,
      "value": "4. Après avoir effectué vos choix, sélectionnez "
    }, {
      "children": [{
        "type": 0,
        "value": "Créer une nouvelle commande"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": "."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "GWvkwO",
    defaultMessage: [{
      "type": 0,
      "value": "Les deux commandes auront la même adresse de livraison et la même date d'expédition prévue, mais la nouvelle commande aura un seul numéro de commande pour la marque."
    }]
  })));
};
var _OrderLinkFormatting = function _OrderLinkFormatting(chunks, brandOrderToken) {
  if (!brandOrderToken) {
    return /*#__PURE__*/React.createElement(Bold, null, chunks);
  } else {
    return /*#__PURE__*/React.createElement(Button, {
      variant: "tertiary",
      linkTo: brandPortalOrdersbrandOrderToken(brandOrderToken),
      target: "_blank"
    }, /*#__PURE__*/React.createElement(Bold, null, chunks));
  }
};
var _BoldFormatting = function _BoldFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Bold, null, chunks);
};